// Temporary screen that shows "Under Construction" message to users without
// OWNER permission.

import backgroundImageUrl from 'assets/images/background-new-50368075.jpg';

import backgroundVideoUrl from 'assets/videos/background-new-50368075.mp4';

import type { FunctionComponent, ReactNode } from 'react';
import { Link } from '@dr.pogodin/react-utils';

import GlassCard from 'components/GlassCard';
import PageWithVideoBackground from 'components/PageWithVideoBackground';

import { useGlobalState } from 'utils/global-state';

import cardTheme from 'themes/GlassCard/login.scss';

import S from './style.scss';

type PropsT = {
  children?: ReactNode;
};

export const BetaTestersOnly: FunctionComponent<PropsT> = ({
  children,
}): ReactNode => {
  const [user] = useGlobalState('user');

  if (user?.permissions.AI_APP_ACCESS) return children;

  return (
    <PageWithVideoBackground
      fallbackImageUrl={backgroundImageUrl}
      noAudioSetup
      videoUrl={backgroundVideoUrl}
    >
      <GlassCard theme={cardTheme}>
        <div className={S.content}>
          <h1>Welcome to Soul&nbsp;Sanctuary!</h1>
          <p>
            Our application is still in its closed beta-testing phase. For early
            access please contact &zwnj;
            <Link to="mailto:admin@mysoulsanctuary.net">
              admin@mysoulsanctuary.net
            </Link>.
          </p>
        </div>
      </GlassCard>
    </PageWithVideoBackground>
  );
};
